import type { ReactNode } from 'react';
import { CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox/Checkbox';
import MuiCheckbox from '@mui/material/Checkbox';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import { styled } from '../styles';
import useFieldId from '../useFieldId';

const StyledMuiFormControlLabel = styled(MuiFormControlLabel)(({ theme }) => ({
  alignItems: 'flex-start',
  '& .MuiFormControlLabel-label.Mui-disabled': {
    color: theme.palette.form.selection.text.disabled,
  },
}));

const StyledMuiCheckbox = styled(MuiCheckbox, {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error?: boolean }>(({ theme: { palette }, error }) => ({
  marginTop: -9,
  color: error ? palette.form.selection.icon.error : palette.form.selection.icon.enabled,
  ...(error && {
    '&.Mui-checked': {
      color: palette.form.selection.icon.error,
    },
  }),
  '&.Mui-disabled': {
    color: palette.form.selection.icon.disabled,
  },
}));

export interface Props extends MuiCheckboxProps {
  label: ReactNode;
  name: string;
  hasError?: boolean;
}

const Checkbox = ({ sx = {}, label, name, hasError, id, ref, ...otherProps }: Props) => {
  const { fieldId } = useFieldId(name, id);

  return (
    <StyledMuiFormControlLabel
      sx={{ width: 1, ...sx }}
      label={label}
      control={
        <StyledMuiCheckbox id={fieldId} name={name} ref={ref} error={hasError} {...otherProps} />
      }
    />
  );
};

export default Checkbox;
